import Axios from 'axios';
var OperationReportService = (function () {
    function OperationReportService() {
    }
    OperationReportService.prototype.getAccountList = function (params) {
        return Axios.get('supplierclientapi/account/list', { params: params });
    };
    OperationReportService.prototype.getOperationType = function (params) {
        return Axios.post("basicapi/operation_log_type", params);
    };
    OperationReportService.prototype.operationList = function (params) {
        return Axios.post("supplierclientapi/operation_log/list", params);
    };
    OperationReportService.createInstance = function () {
        OperationReportService.getInstance();
    };
    OperationReportService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return OperationReportService;
}());
export default OperationReportService;
